export const gato = [
  {
    id:1,
    raza:'Bengala',
    price:'15000',
    origin:'Estados Unidos',
    image:'Images/bengal.png',
    image2:'Images/bengala2.png',
    image3:'Images/bengala3.png',
    imagenes: ['bengala/bengala4.png','bengala/bengala5.png','bengala/bengal6.png','bengala/bengala7.png',
      'bengala/bengal8.png','bengala/bengala9.png'],
    phone:'(212) 555-1234',
    email:'bengala@cat.com.mx',
    descripcion: 'El bengalí es un gato grande, elegante y muy musculoso, con una cola espesa que suele llevar baja. El aspecto salvaje del bengalí lo realza su característico pelaje: moteado o marmolado, espeso y suntuoso. Su cabeza ancha tiene orejas pequeñas y mejillas pronunciadas, los ojos tienen un contorno negro y forma almendrada. La cola es gruesa, aunque se estrecha hacia la punta, de color negro. No hay ninguna otra raza felina que muestre el efecto brillo de oro o de perla que se encuentra en algunos bengalíes. Estos, además, pueden ser muy exigentes por sus altos niveles de actividad.',
    personalidad: 'Los gatos bengalíes muestran seguridad y confianza en sí mismos y, además, son cariñosos. Son muy juguetones por naturaleza y rebosan energía. Los bengalíes son listos y parece que miren todo lo que les rodea, incluido al perro de la familia, como preguntándose: «¿Puedo jugar con esto?». Son ágiles, les encanta trepar y pueden ser bastante maulladores, con una voz característica que se describe como un arrullo, gorjeo o un sonido áspero extraño. Los bengalíes son una raza muy maulladora y tienen un amplio vocabulario que puede llegar a ser bastante estridente, sobre todo en situaciones que no les resulten familiares. Necesitan compañía durante el día para no aburrirse.',
    caracteristicas1:'Gato muy curioso y activo',
    caracteristicas2:'Gato sociable y dependiente',
    caracteristicas3:'Gato muy maullador',
    caracteristicas4:'Raza de gato esbelta y elegante',
    caracteristicas5:'Requiere aseo una vez por semana',
    caracteristicas6:'Raza alergénica',
    caracteristicas7:'Gato al aire libre',
    caracteristicas8:'Puede requerir familiarización antes de vivir con niños',
    caracteristicas9:'País de origen: EE. UU.'
  },
  {
    id:2,
    raza:'Bombay',
    price:'3000',
    origin:'Estados Unidos',
    image:'Images/bombay.png',
    image2:'Images/bombay2.png',
    image3:'Images/bombay3.png',
    imagenes:{
          image4:'bombay/bombay4.png',
          image5:'bombay/bombay5.png',
          image6:'bombay/bombay6.png',
          image7:'bombay/bombay7.png',
          image8:'bombay/bombay8.png',
          image9:'bombay/bombay9.png',
          image10:'bombay/bombay10.png',
          image11:'bombay/bombay11.png',
          image12:'bombay/bombay12.png',
          image13:'bombay/bombay13.png',
          image14:'bombay/bombay14.png',
    },
    phone:'(212) 556-6534',
    email:'bombay@cat.com.mx',
    descripcion: 'El bombay es un gato de constitución media y un pelaje negro azabache muy brillante que parece charol. El cráneo es ligeramente redondeado, tiene las orejas redondeadas y un hocico ancho. Sus preciosos ojos de color cobre o dorado están bastante separados y son intensos y expresivos. El cuerpo es firme y musculoso, con un lomo recto y fuerte. La trufa y el contorno del ojo son negros y las almohadillas de las patas son negras o de color marrón oscuro.',
    personalidad: 'Los gatos del grupo de razas asiáticas son muy amistosos y cariñosos. Los bombay tienen una voz característica y suelen ser muy maulladores. No tienen un maullido tradicional.',
    caracteristicas1:'Gato curioso y juguetón',
    caracteristicas2:'Gato sociable y dependiente',
    caracteristicas3:'Gato muy maullador',
    caracteristicas4:'Raza de gato de constitución media',
    caracteristicas5:'Requiere aseo una vez por semana',
    caracteristicas6:'Raza alergénica',
    caracteristicas7:'Necesita algo de espacio al aire libre',
    caracteristicas8:'Puede requerir familiarización antes de vivir con niños',
    caracteristicas9:'País de origen: Gran Bretaña y EE. UU.'
  },
  {
    id:3,
    raza:'British Short Cut',
    price:'10000',
    origin:'Reino Unido',
    image:'Images/brithisShortCut.png',
    image2:'Images/britishShortCut2.png',
    image3:'Images/britishShortCut3.png',
    imagenes:{
          image4:'britishShortCut/britishShortCut4.png',
          image5:'britishShortCut/britishShortCut5.png',
          image6:'britishShortCut/britishShortCut6.png',
          image7:'britishShortCut/britishShortCut7.png',
          image8:'britishShortCut/britishShortCut8.png',
          image9:'britishShortCut/britishShortCut9.png',
          image10:'britishShortCut/britishShortCut10.png',
          image11:'britishShortCut/britishShortCut11.png',
          image12:'britishShortCut/britishShortCut12.png',
          image13:'britishShortCut/britishShortCut13.png',
          image14:'britishShortCut/britishShortCut14.png',
    },
    phone:'(212) 589-4524',
    email:'britishShortCut@cat.com.mx',
    descripcion: 'El británico de pelo corto es una raza relativamente grande que podría describirse como gruesa o fornida. Tiene muchos contornos redondeados: la cara y las mejillas, las orejas, los ojos y la cabeza. La trufa, corta y ancha, descansa sobre un mentón fuerte y profundo, lo que unido a su pecho y su cola corta y gruesa le convierten en un gato fuerte y robusto. El pelaje, corto y denso sin ser esponjoso, puede presentar más de cien combinaciones distintas de colores y dibujos.',
    personalidad: 'Los británicos de pelo corto con los «gigantes bonachones» del mundo felino. Son amables y cariñosos con los humanos y con los demás animales. Los británicos de pelo corto no piden una atención humana constante y son más tranquilos que sus congéneres orientales; además, tampoco comparten esa naturaleza curiosa que lleva a muchas razas orientales a meterse en problemas.',
    caracteristicas1:'Gato curioso y juguetón',
    caracteristicas2:'Gato amigable pero independiente',
    caracteristicas3:'Un gato silencioso',
    caracteristicas4:'Raza de gato más grande y robusta',
    caracteristicas5:'Requiere aseo una vez por semana',
    caracteristicas6:'Raza alergénica',
    caracteristicas7:'Necesita algo de espacio al aire libre',
    caracteristicas8:'Puede requerir familiarización antes de vivir con niños',
    caracteristicas9:'País de origen: Gran Bretaña'
    
  },
  {
    id:4,
    raza:'Korat',
    price:'10000',
    origin:'Tailandia',
    image:'Images/korat.png',
    image2:'Images/korat2.png',
    image3:'Images/korat3.png',
    imagenes:{
          image4:'korat/korat4.png',
          image5:'korat/korat5.png',
          image6:'korat/korat6.png',
          image7:'korat/korat7.png',
          image8:'korat/korat8.png',
          image9:'korat/korat9.png',
          image10:'korat/korat10.png',
          image11:'korat/korat11.png',
          image12:'korat/korat12.png',
          image13:'korat/korat13.png',
          image14:'korat/korat14.png',
    },
    phone2:'(212) 123-7814',
    email:'korat@cat.com.mx',
    descripcion: 'El pelaje del korat es corto, fino y brillante y ceñido al cuerpo. Se presenta en un único color, que consiste en un tono azul con las puntas plateadas. La trufa, los labios y las almohadillas de las patas son de color azul grisáceo oscuro o lavanda. Su aspecto es parecido al azul ruso, pero tiene un manto monocapa, una forma más redondeada y los ojos de un verde peridoto en lugar de verde esmeralda. La cabeza tiene una forma de corazón muy característica, con orejas y ojos grandes y una expresión de alerta. El cuerpo es fuerte y musculoso; ni tan largo como el siamés ni tan fornido como el británico de pelo corto.',
    personalidad: 'Los korat tienen un carácter tranquilo y dulce, pero muy inteligente y juguetón. Son unas mascotas ideales y se muestran entregados con sus compañeros humanos.',
    caracteristicas1:'Gato curioso y juguetón',
    caracteristicas2:'Gato amigable pero independiente',
    caracteristicas3:'Un gato silencioso',
    caracteristicas4:'Raza de gato de constitución media',
    caracteristicas5:'Requiere aseo una vez por semana',
    caracteristicas6:'Raza alergénica',
    caracteristicas7:'Necesita algo de espacio al aire libre',
    caracteristicas8:'Puede requerir familiarización antes de vivir con niños',
    caracteristicas9:'País de origen: Tailandia'
  },
  {
    id:5,
    raza:'Ragdoll',
    price:'10000',
    origin:'Inglaterra',
    image:'Images/ragdoll.png',
    image2:'Images/ragdoll2.png',
    image3:'Images/ragdoll3.png',
    imagenes:{
          image4:'ragdoll/ragdoll4.png',
          image5:'ragdoll/ragdoll5.png',
          image6:'ragdoll/ragdoll6.png',
          image7:'ragdoll/ragdoll7.png',
          image8:'ragdoll/ragdoll8.png',
          image9:'ragdoll/ragdoll9.png',
          image10:'ragdoll/ragdoll10.png',
          image11:'ragdoll/ragdoll11.png',
          image12:'ragdoll/ragdoll12.png',
          image13:'ragdoll/ragdoll13.png',
          image14:'ragdoll/ragdoll14.png',
    },
    phone:'(212) 580-5684',
    email:'ragdoll@cat.com.mx',
    descripcion: 'El ragdoll es un gato grande, fuerte e imponente con unas manchas características. Sin embargo, es un gato muy relajado y tranquilo que da la impresión de ser una muñeca de trapo. Tiene la cabeza ancha con la parte superior plana y un amplio espacio entre las orejas. Tiene unos ojos muy grandes de color azul intenso. El cuerpo es largo y musculoso. Tiene un pecho amplio, el cuello corto y las patas fornidas. Las zarpas son grandes, redondeadas y peludas, y la cola es larga y tupida. El pelaje del ragdoll es sedoso y denso, de longitud mediana a larga; los gatos adultos pueden tener gorguera y calzón. Hay tres patrones de pelaje diferentes en la raza ragdoll y cada uno se presenta en cuatro colores. También se puede encontrar un ragdoll con «guantes» blancos y otras manchas también blancas.',
    personalidad: 'El ragdoll es posiblemente el gato más tranquilo de todas las razas de gatos domésticos. Son gatos que se conforman bastante, no son exigentes y toleran la mayoría de las situaciones. Tienen un carácter muy tranquilo y relajado, lo que les convierte en mascotas fieles y entregadas. Hay quien cree que estos gatos son inmunes al dolor, pero esto es rotundamente falso. Su comportamiento relajado deriva de un carácter muy confiado y no de una ausencia de sensibilidad.',
    caracteristicas1:'Gato tranquilo',
    caracteristicas2:'Gato sociable y dependiente',
    caracteristicas3:'Un gato silencioso',
    caracteristicas4:'Raza de gato más grande y robusta',
    caracteristicas5:'Requiere aseo todos los días',
    caracteristicas6:'Raza alergénica',
    caracteristicas7:'Necesita algo de espacio al aire libre',
    caracteristicas8:'Buen gato familiar',
    caracteristicas9:'País de origen: Estados Unidos'
  },
  {
    id:6,
    raza:'Persian',
    price:'10000',
    origin:'Persia',
    image:'Images/persian.png',
    image2:'Images/Persian2.png',
    image3:'Images/Persian3.png',
    imagenes:{
          image4:'persian/persian4.png',
          image5:'persian/persian5.png',
          image6:'persian/persian6.png',
          image7:'persian/persian7.png',
          image8:'persian/persian8.png',
          image9:'persian/persian9.png',
          image10:'persian/persian10.png',
          image11:'persian/persian11.png',
          image12:'persian/persian12.png',
          image13:'persian/persian13.png',
          image14:'persian/persian14.png',
    },
    phone:'(212) 555-1134',
    email:'persian@cat.com.mx',
    descripcion:'El persa de pelo largo es un gato fornido de tamaño mediano con una cabeza muy grande en proporción a su cuerpo. Tiene la cabeza redondeada y ancha, las orejas pequeñas y separadas, y la cara corta y despejada. Los ojos son grandes y redondos y tienen un color vivo. Las patas son cortas, gruesas y fuertes, con zarpas grandes y redondeadas y dedos copetudos. La cola es corta y tupida. El pelaje es largo, grueso y exuberante, con una capa interna densa y suave El persa presenta una gran variedad de patrones y colores.',
    personalidad: 'El persa de pelo largo es tranquilo y cariñoso. Es apacible y no tan activo como algunas razas de pelo corto. En general, no le importa vivir solo y se muestra bastante contento de ser gato único. Le basta con estar sentado tranquilo y tener buen aspecto.',
    caracteristicas1:'Gato tranquilo',
    caracteristicas2:'Gato amigable pero independiente',
    caracteristicas3:'Un gato silencioso',
    caracteristicas4:'Raza de gato más grande y robusta',
    caracteristicas5:'Requiere aseo todos los días',
    caracteristicas6:'Raza alergénica',
    caracteristicas7:'Necesita algo de espacio al aire libre',
    caracteristicas8:'Puede requerir familiarización antes de vivir con niños',
    caracteristicas9:'País de origen: Turquía e Irán'
  },
  {
    id:7,
    raza:'Scottish fold',
    price:'11000',
    origin:'Escocia',
    image:'Images/scottishFold.png',
    image2:'Images/ScottishFold2.png',
    image3:'Images/ScottishFold3.png',
    imagenes:{
          image4:'scottishFold/scottishFold4.png',
          image5:'scottishFold/scottishFold5.png',
          image6:'scottishFold/scottishFold6.png',
          image7:'scottishFold/scottishFold7.png',
          image8:'scottishFold/scottishFold8.png',
          image9:'scottishFold/scottishFold9.png',
          image10:'scottishFold/scottishFold10.png',
          image11:'scottishFold/scottishFold11.png',
          image12:'scottishFold/scottishFold12.png',
          image13:'scottishFold/scottishFold13.png',
          image14:'scottishFold/scottishFold14.png',
    },
    phone:'(212) 555-8978',
    email:'scottishFold@cat.com.mx',
    descripcion:'La característica más evidente del fold son sus orejas, que son pequeñas y están dobladas hacia adelante de tal modo que cubren la abertura de la oreja por completo. Tiene las puntas de las orejas redondeadas. El fold escocés es un gato de tamaño mediano con un cuerpo firme y compacto. La cabeza tiene una forma redondeada, con pómulos salientes y se asienta sobre un cuello corto. Los ojos son grandes, muy abiertos y de expresión dulce. El pelaje del fold escocés es corto y denso. Tiene una gran variedad de colores y patrones.',
    personalidad: 'El fold escocés tiene un carácter dulce y apacible a pesar de su extraño aspecto. Los folds no son una raza activa, algo que puede deberse a que el movimiento les causa dolor.',
    caracteristicas1:'Gato tranquilo',
    caracteristicas2:'Gato amigable pero independiente',
    caracteristicas3:'Un gato silencioso',
    caracteristicas4:'Raza de gato de constitución media',
    caracteristicas5:'Requiere aseo una vez por semana',
    caracteristicas6:'Raza alergénica',
    caracteristicas7:'Gato de interior',
    caracteristicas8:'Puede requerir familiarización antes de vivir con niños',
    caracteristicas9:'País de origen: Escocia'
  },
  {
    id:8,
    raza:'Maine coon',
    price:'20000',
    origin:'Estados Unidos',
    image:'Images/maineCoon.png',
    image2:'Images/maineCoon2.png',
    image3:'Images/maineCoon3.jpg',
    imagenes:{
          image4:'maineCoon/maineCoon4.png',
          image5:'maineCoon/maineCoon5.png',
          image6:'maineCoon/maineCoon6.png',
          image7:'maineCoon/maineCoon7.png',
          image8:'maineCoon/maineCoon8.png',
          image9:'maineCoon/maineCoon9.png',
          image10:'maineCoon/maineCoon10.png',
          image11:'maineCoon/maineCoon11.png',
          image12:'maineCoon/maineCoon12.png',
          image13:'maineCoon/maineCoon13.png',
          image14:'maineCoon/maineCoon14.png',
    },
    phone:'(212) 552-1245',
    email:'MaineCoon@cat.com.mx',
    descripcion:'Los gatos maine coon, considerada la mayor de todas las razas de gatos, tienen un cuerpo de fuerte musculatura y patas sólidas. Tiene un hocico cuadrado y unas orejas grandes que se sostienen anchas y erguidas. El pelaje es largo y grueso, con un manto inferior cubierto por un abundante pelo impermeable y brillante. El pelo de la cabeza, del cuello y del torso es más corto y aumenta de longitud al bajar por el lomo, los costados y la cola. El pelo del vientre y de las patas traseras es abundante y lanudo. Tiene una gorguera que empieza en la base de las orejas y es más densa en los machos que en las hembras. El pelo de la cola es largo y suelto. Las orejas presentan mechones en las puntas. Las zarpas tienen también unos mechones que les dan el aspecto de raquetas para la nieve. El maine coon puede presentar más de 30 colores. Los ojos pueden ser verdes, dorados o cobrizos; en los gatos blancos es posible encontrar ojos azules o de distinto color cada uno.',
    personalidad: 'Los maine coon tienen un carácter dulce y son muy juguetones y amistosos. Les gusta mucho la compañía humana y son buenas mascotas. Tal vez debido a su origen humilde, están acostumbrados a dormir a la intemperie, acurrucados en los lugares más insospechados. Disfrutan con la vida al aire libre y les gusta poder trepar y simular la caza. Los maine coon destacan por el encantador gorjeo bajo que emiten.',
    caracteristicas1:'Gato muy curioso y activo',
    caracteristicas2:'Gato sociable y dependiente',
    caracteristicas3:'Gato algo maullador',
    caracteristicas4:'Raza de gato más grande y robusta',
    caracteristicas5:'Requiere aseo todos los días',
    caracteristicas6:'Raza alergénica',
    caracteristicas7:'Gato al aire libre',
    caracteristicas8:'Buen gato familiar',
    caracteristicas9:'País de origen: Estados Unidos'
  }
];

